import React, { useCallback, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { getPlayerGameHistoryGanamos } from '../../../../../../Api/UserPanel/UserPanel'
import { BiLoaderCircle } from 'react-icons/bi'

interface Props {
    show: boolean
    onHide: () => void
    form: {
        name: string
    }
}

enum StatusOptions {
    Ganado = '1',
    Perdido = '2',
    Reembolso = '3'
}


export const PlayerGameHistoryBetMoney = ({ show, onHide, form }: Props) => {
    const [playerGameHistory, setPlayerGameHistory] = useState<any | null>(null)

    const [selectedStatus, setSelectedStatus] = useState<StatusOptions>(StatusOptions.Ganado)
    const [loading, setLoading] = useState(false)

    const getGameHistory = useCallback(async () => {
        setLoading(true)
        const response = await getPlayerGameHistoryGanamos({ name: form?.name?.trim(), status: selectedStatus })
        if (response?.data && response?.data?.content?.list) {
            setPlayerGameHistory(response.data.content.list)
        } else {
            setPlayerGameHistory([])
        }

        setLoading(false)
    }, [form.name, selectedStatus])


    useEffect(() => {
        getGameHistory()
    }, [getGameHistory])


    const getStatusColor = (status: string) => {
        if (String(status) === StatusOptions.Ganado) return 'green'
        if (String(status) === StatusOptions.Perdido) return 'red'
        if (String(status) === StatusOptions.Reembolso) return 'orange'
    }



    const getStatusLabel = (status: StatusOptions) => {
        if (String(status) === StatusOptions.Ganado) return 'Ganado'
        if (String(status) === StatusOptions.Perdido) return 'Perdido'
        if (String(status) === StatusOptions.Reembolso) return 'Reembolso'
    }


    return (
        <Modal show={show} onHide={onHide} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Historial de Juego {form.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex justify-content-between align-items-center'>
                    <span>Últimos 30 días</span>
                </div>


                {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                    <div className='spin-animation d-flex align-items-center justify-content-center'>
                        <BiLoaderCircle size={20} />
                    </div>
                    <span>Cargando...</span>
                </div>}

                {!loading && playerGameHistory && (
                    <>
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Juego</th>
                                        <th>Proveedor</th>
                                        <th>Apuesta</th>
                                        <th>Ganancia</th>
                                        <th>Moneda</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {Array.isArray(playerGameHistory) && playerGameHistory?.map((entry: any, index: number) => (
                                        <tr key={index}>
                                            <td>{new Date(new Date(entry.start).getTime() - 3 * 60 * 60 * 1000).toLocaleString()}</td>
                                            <td>{entry.gameName || 'N/A'}</td>
                                            <td>{entry.gameProvider}</td>
                                            <td>{entry.bet}</td>
                                            <td>{entry.win}</td>
                                            <td>{entry.currency}</td>
                                            <td style={{ color: getStatusColor(entry.status) }}>{getStatusLabel(entry.status)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {
                                playerGameHistory?.length === 0 && <div className='d-flex justify-content-center my-5'>
                                    <span>No hay historial</span>
                                </div>
                            }
                        </div>
                    </>

                )}
            </Modal.Body>
            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
